import appManager from '@app/appManager';
import { CallEvent } from '@modules/SoftPhoneModule/types';
import TasksModule from '@modules/TasksModule';
import { findStlTaskForCall } from './findStlTaskForCall';

const logger = appManager.logger('SpeedToLead');

/**
 * Handles phone.call.answered for STL tasks.
 * Sets `hasCallConnected` when the remote party answers, which enables
 * the "Book Job" button in the UI.
 */
function handleStlCallAnswered(event: CallEvent) {
  if (!event.originating) return;

  const stlTask = findStlTaskForCall(event.remoteIdentity);
  if (!stlTask) return;

  logger.info('stl:call-answered:connected', { taskId: stlTask.id });
  TasksModule.setTaskAttribute(stlTask.id, 'hasCallConnected', true);
}

export default handleStlCallAnswered;
